import { render, staticRenderFns } from "./ContentTable.vue?vue&type=template&id=365a67bf&"
import script from "./ContentTable.vue?vue&type=script&lang=js&"
export * from "./ContentTable.vue?vue&type=script&lang=js&"
import style0 from "./ContentTable.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports